import * as Immutable from 'immutable';

export const userAccountStructure = {
  firstName: ['firstName'],
  lastName: ['lastName'],
  fullName: ['fullName'],
  telephone: ['telephone'],
  allowSMS: ['settings', 'communication', 'allowSMS'],
  gender: ['gender'],
  resume: ['resume'],
  country: ['address', 'country'],
  street: ['address', 'street'],
  city: ['address', 'city'],
  state: ['address', 'state'],
  postalCode: ['address', 'postalCode'],
  university: ['education', 'university'],
  degree: ['education', 'degree'],
  graduationYear: ['education', 'graduationYear'],
  major: ['education', 'major'],
  gpa: ['education', 'gpa'],
  maxGPA: ['education', 'maxGPA'],
  stem: ['education', 'stem'],
  presently_employed: ['presently_employed'],
  employer: ['employment', 'employer'],
  title: ['employment', 'title'],
  business: ['employment', 'business'],
  description: ['employment', 'description'],
  participationPermitted: ['employment', 'participationPermitted'],
  nonPublicInformation: ['employment', 'nonPublicInformation'],
  finance: ['employment', 'finance'],
  investmentAdvisory: ['employment', 'investmentAdvisory'],
  brokerage: ['employment', 'brokerage'],
  fundamentalResearch: ['employment', 'fundamentalResearch'],
  proprietaryTrading: ['employment', 'proprietaryTrading'],
  serviceEngagement: ['employment', 'serviceEngagement'],
  exposureStatus: ['employment', 'exposureStatus'],
  exposureDetails: ['employment', 'exposureDetails'],
  employerServices: ['employment', 'employerServices'],
  publicPhoto: ['settings', 'privacy', 'image', 'visibility'],
  publicName: ['settings', 'privacy', 'name', 'visibility'],
  codingProficiency: ['recruitment', 'codingProficiency'],
  englishProficiency: ['recruitment', 'englishProficiency'],
  roleInterest: ['recruitment', 'roleInterest'],
  photo: ['photo'],
};

export const publicFields = Immutable.List<keyof typeof userAccountStructure>(['publicPhoto', 'publicName']);

export const userDataBooleanFields = Immutable.List([
  'allowSMS',
  'stem',
  'presently_employed',
  'nonPublicInformation',
  'participationPermitted',
  'finance',
  'investmentAdvisory',
  'brokerage',
  'fundamentalResearch',
  'proprietaryTrading',
  'serviceEngagement',
  'exposureStatus',
  'agree',
]);

export const UserEmploymentFields = Immutable.List([
  'presently_employed',
  'employer',
  'title',
  'business',
  'description',
  'participationPermitted',
  'nonPublicInformation',
  'finance',
  'brokerage',
  'investmentAdvisory',
  'fundamentalResearch',
  'proprietaryTrading',
  'serviceEngagement',
  'exposureStatus',
  'employerServices',
  'exposureDetails',
]);

export const UserFinanceFields = Immutable.List([
  'brokerage',
  'investmentAdvisory',
  'fundamentalResearch',
  'proprietaryTrading',
  'serviceEngagement',
  'exposureStatus',
  'employerServices',
  'exposureDetails',
]);

export const updateSlugs: string[] = [
  'basic-details',
  'location',
  'education',
  'employment',
  'recruitment',
  'access-token',
  'recertify-account',
];

export const updateSlugsRecertification: string[] = [
  'basic-details',
  'location',
  'education',
  'employment',
  'recruitment',
  'recertify-account',
];

export const titles = [
  'account.titles.basic.details',
  'account.titles.location',
  'account.titles.education',
  'account.titles.employment',
  'account.titles.recruitment',
  'account.titles.recertify.account',
];

export const stepTitles = [
  'account.step.titles.basic.details',
  'account.step.titles.location',
  'account.step.titles.education',
  'account.step.titles.employment',
  'account.step.titles.recruitment',
  'account.step.titles.access-token',
  'account.step.titles.recertify.account',
];

export const stepTitlesRecertification = [
  'account.step.titles.basic.details',
  'account.step.titles.location',
  'account.step.titles.education',
  'account.step.titles.employment',
  'account.step.titles.recruitment',
  'account.step.titles.recertify.account',
];

export const orderOfActivities: any = [
  'actual-weight',
  'discretionary-payment',
  'productions',
  'base-payment',
  'submissions',
  'simulations',
];

export const recertifyInfo = [
  'account.recertify.info',
  'account.recertify.info',
  'account.recertify.info',
  'account.recertify.info-employment',
  'account.recertify.info-recruitment',
  'account.recertify.info-confirm',
];
